"use client";
import Link from 'next/link';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { SERVICES } from '@/lib/constants';
import { useScrollAnimation } from '@/lib/useScrollAnimation';

export function ServicesGrid() {
  const { ref, isVisible } = useScrollAnimation();
  const items = SERVICES.filter((s) =>
    ['stucco-repair', 'plaster-installation', 'texture-matching', 'drywall-repair', 'drywall-installation'].includes(s.slug)
  );
  
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="section-padding bg-neutral-50">
      <div className="container">
        <div className={`text-center mb-12 ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Our Expert Services
          </h2>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Professional plastering and drywall solutions tailored to your needs
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((svc, index) => (
            <Link 
              key={svc.slug} 
              href={`/services/${svc.slug}`}
              className={`group ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <Card className="h-full transition-all duration-300 hover:shadow-lg hover:-translate-y-2 cursor-pointer border-neutral-200">
                <CardHeader className="space-y-2">
                  <h3 className="font-bold text-xl text-primary group-hover:text-[color:var(--color-primary-hover)] transition-colors">
                    {svc.name}
                  </h3>
                  <p className="text-sm text-muted font-medium">
                    {svc.short}
                  </p>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-base text-secondary leading-relaxed">
                    {svc.description}
                  </p>
                  <span className="inline-flex items-center text-sm font-semibold text-[color:var(--color-primary)] group-hover:text-[color:var(--color-primary-hover)] group-hover:gap-2 transition-all">
                    Learn more 
                    <span className="ml-1 group-hover:ml-2 transition-all">→</span>
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
